import React, { useState, useEffect, useMemo } from 'react';
import { GenderButton } from './GenderButton.tsx';
import { LoadingSpinner } from '../Loading.tsx';
import { CollectionReptile } from '../collection/types/CollectionTypes.ts';
import { Morph } from '../../types/Morph.ts';
import { Placeholder, Button } from 'react-bootstrap';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export const ReptileTile = ({ reptile, clickEvent, deleteSelectedActive, onSelected, morphInfo, buttonText = "Details", hideButton = false, variant = '', working = false }: {
  reptile: CollectionReptile,
  clickEvent?: (reptile: CollectionReptile) => void,
  deleteSelectedActive?: boolean,
  onSelected?: () => void,
  morphInfo?: Morph | null,
  buttonText?: string,
  hideButton?: boolean,
  variant?: string,
  working?: boolean
}) => {
  const selectedClass = deleteSelectedActive ? 'selected-delete-item' : 'selected-item';
  let currentCredit = '';
  let picture = reptile.picture || reptile.pictures?.[0] || reptile.img || "images/notavailable.jpg";
  if (!picture || picture === "" || picture === "images/notavailable.jpg") {
    if (morphInfo && morphInfo.pictures && morphInfo.pictures[0]) {
      const morphPic = morphInfo.pictures[0];
      picture = morphPic.url;
      currentCredit = morphPic.credit;
    }
  }
  const hasOwnPicture = reptile.pictures.length > 0;
  const [displayPhoto, setDisplayPhoto] = useState(picture)
  const [credit, setCredit] = useState(currentCredit)
  const [photoLoading, setPhotoLoading] = useState(true);
  const isSelectedReptile = useMemo(() => reptile.reptile === localStorage.getItem('selectedReptile'), [reptile.reptile])
  useEffect(() => {
    if (!isSelectedReptile) {
      return;
    }
    if (!hasOwnPicture && (!displayPhoto || displayPhoto.match("notavailable"))) {
      if (morphInfo && morphInfo.pictures && morphInfo.pictures[0]) {
        const morphPic = morphInfo.pictures[0];
        setDisplayPhoto(morphPic.url);
        setCredit(morphPic.credit);
      } else {
        setDisplayPhoto("images/notavailable.jpg");
        setCredit("");
      }
    }
  }, [morphInfo])
  useEffect(() => {
    if (!hasOwnPicture && !isSelectedReptile) {
      getDefaultPhoto();
    } else if (!hasOwnPicture && reptile.picture && reptile.picture !== "" && reptile.picture !== "images/notavailable.jpg") {
      setDisplayPhoto(reptile.picture)
    }
  }, [reptile.picture])

  const getDefaultPhoto = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}collection_reptile_photo/${reptile.id}/get_default`,
      onSuccess: (data: { picture: { url: string, id: number, credit: string } | null }) => {
        if (data.picture) {
          setDisplayPhoto(data.picture.url);
          setCredit(data.picture.credit);
        } else {
          setDisplayPhoto("images/notavailable.jpg");
          setCredit("");
        }
      }
    })
  }

  return (
    <div onClick={onSelected ? onSelected : () => { }} className={`col-6 col-md-4 text-center reptile-tile-container`}>
      <div className={`reptile-tile h-100 p-2 d-flex flex-column justify-content-between ${reptile.selected ? selectedClass : ''} ${variant}`}>
        <div className="d-flex flex-row mb-2 justify-content-between">
          <h6 className="reptile-name align-self-center">{reptile.name !== '' ? reptile.name : reptile.morph_name}</h6>
          <span><GenderButton gender={reptile.gender} /></span>
        </div>
        <div
          className='d-flex flex-column'
          style={{
            backgroundImage: `url(${displayPhoto})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: !photoLoading ? 150 : 0,
          }}>
          <img src={displayPhoto} onLoad={() => setPhotoLoading(false)} className="d-none" alt="" />
        </div>
        {photoLoading && <div className='d-flex '>
          <LoadingSpinner />
        </div>}

        <div>
          <h6 className="tile-photo-credit mt-2 ">{credit}</h6>

        </div>
        {reptile.status === "sold" && reptile.sold_price && reptile.sold_price !== -1 && reptile.sold_price !== "null" && <h6 className='price'>${reptile.sold_price}</h6>}
        {!hideButton && clickEvent && <Button disabled={working} className="w-100 mt-2" variant='outline-light' onClick={(event) => { event.stopPropagation(); clickEvent(reptile); }}>{working ? <FontAwesomeIcon spin icon={faSpinner} /> : buttonText}</Button>}
      </div>
    </div>
  )
}


export const ReptileTilePlaceholder = ({ hideButton }) => (
  <div className={`col-6 col-md-4 text-center reptile-tile-container`}>
    <div className={`reptile-tile h-100 d-flex flex-column justify-content-between`}>
      <div className="d-flex flex-row my-2 justify-content-between">
        <Placeholder as='h6' animation="wave" bg="secondary" className="reptile-name align-self-center my-auto" style={{ width: 150, height: 20 }} />
        <Placeholder bg='secondary' className='rounded' style={{ height: 45, width: 35 }} animation="wave" />
      </div>
      <Placeholder bg="secondary" style={{ height: 150 }} animation="wave" />


      <div>
        <Placeholder as='h6' animation="wave" bg="secondary" className='mt-2 mx-auto mb-2' style={{ width: 200, height: 20 }} />

      </div>
      {!hideButton && <Placeholder.Button animation="wave" bg="secondary" className="border-0" style={{ height: 45 }} />}
    </div>
  </div>
)

